import { isNullish } from "types/guards";

export type FeatureFlagEntryT = {
  name: string;
  userIds: string[] | null;
};

const parseFeatureFlagEntry = (rawEntry: string): FeatureFlagEntryT => {
  const [name, userIdsList] = rawEntry.split(":");
  const userIds = userIdsList ? userIdsList.split(",").filter(Boolean) : null;

  return { name, userIds };
};

const FEATURE_FLAG_ENTRIES: FeatureFlagEntryT[] = process.env.REACT_APP_FEATURE_FLAGS
  ? process.env.REACT_APP_FEATURE_FLAGS.split(" ").filter(Boolean).map(parseFeatureFlagEntry)
  : [];

export const isFeatureEnabled = (flag: string, userId?: number | string | null): boolean => {
  const entry = FEATURE_FLAG_ENTRIES.find(({ name }) => name === flag);

  if (!entry) {
    return false;
  }

  if (entry.userIds === null) {
    return true;
  }

  if (isNullish(userId)) {
    return false;
  }

  return entry.userIds.includes(String(userId));
};

const FEATURE_FLAGS: string[] = FEATURE_FLAG_ENTRIES.filter(({ userIds }) => userIds === null).map(({ name }) => name);

export default FEATURE_FLAGS;
